var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"reload-btn",class:_vm.isLoading ? 'active' : '',attrs:{"outlined":"","small":"","disabled":_vm.isDisable},on:{"click":_vm.reload}},[_c('v-icon',[_vm._v("mdi-reload")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }